export const hildegardEt = `<h3><b>Bingeni Hildegard (1098-1179)</b></h3>
                <br/>
                <p>Hildegard oli erakordse andega naine, kelle looming inspireerib meid tänaseni.
                    Ta oli ühtaegu nii benediktiini abtiss kui ka kirikuarst, teadlane ja filosoof, teerajaja ja
                    prohvet, teoloog ja kristlik müstik, helilooja, kunstnik ja poeet.</p>
                <p>Hildegard sündis Saksamaal aadliperekonna 10. lapsena. Lapsest saati kloostris elades
                    omandas ta hea hariduse. Tema intellekt ja suur lugemus lõid põhja mitmekülgsetele
                    süsteemsetele teadmistele. Hoolimata sellest, et ta elas kogu oma elu Reinimaal Bingenis,
                    on tema looming jäänud 900 aastaks ülemaailmselt teed rajama.</p>
                <p>Püha Hildegard on Saksamaal tuntud alternatiivmeditsiini algatajana. Tal lasus abtissina
                    kohustus ravitseda, kasutades selleks loodusmeditsiini. “Physica” esimene osa käsitleb 230
                    taime, kirjeldab looduse elemente ja nende põhiomadusi, raviväärtusi ja nende
                    kasutamisjuhiseid inimese hinge ja füüsilise tervise toetamiseks. “Physicat” võib käsitleda
                    kui praktilist rahvaravi ja kloostrimeditsiini käsiraamatut. “Füüsikaaedadeks” nimetati
                    kloostrite ja meditsiinikoolide juurde kuulunud ravimtaimede aedu, kus taimi kasvatati ja
                    uuriti.</p>

                <p>Hildegardi 9 soovitust vaimu, meele ja keha tasakaalus hoidmiseks, mis kõlavad tänapäevalgi
                    väga aktuaalselt:

                <ol>
                    <li>Tunne looduse elemente!</li>
                    <li>Mõtesta mikrokosmos ja makrokosmos!</li>
                    <li>Hoia tasakaal ja harmoonia nii eluviisis kui toitumises!</li>
                    <li>Ole järjekindel ja alandlik töös heaolu suunas!</li>
                    <li>Veeda aega väljas, paku oma kehale head puhkust looduses!</li>
                    <li>Praktiseeri mõõdukust eluviisides!</li>
                    <li>Hoia optimismi ja elujõudu, mis on rajatud väärtustele ja enesearengule!</li>
                    <li>Suhtu oma toitu kui ravimisse!</li>
                    <li>Ole koos jumaliku haljendava väega ehk rohelise energiaga, millest saad ammutada
                        elujõudu!
                    </li>
                </ol>
                </p>

                <p>Hildegardi tsitaat: "Haigus ei ole protsess, vaid protsessi puudumine, see on
                    ebaõnnestumine loodusega koos kulgemises."</p>

                <br>

                <b>“Armastus paneb inimesele alguse. Alandlikkus päästab inimese.”</b>`


export const hildegardEn = `<h3><b>Hildegard of Bingen (1098-1179)</b></h3>

                <br/>

                <p>Hildegard was an exceptionally talented woman whose work continues to inspire us today. She was both
                    a Benedictine abbess and a church physician, scientist and philosopher, trailblazer and prophet,
                    theologian and Christian mystic, composer, artist, and poet.</p>

                <p>Hildegard was born in Germany as the 10th child of a noble family. Growing up in a monastery, she
                    received a good education. Her intellect and extensive reading laid the foundation for her diverse
                    and systematic knowledge. Despite living her entire life in Bingen on the Rhine, her work has paved
                    the way globally for 900 years.</p>

                <p>Saint Hildegard is known in Germany as the founder of alternative medicine. As an abbess, she was
                    responsible for healing using natural medicine. The first part of "Physica" deals with 230 plants,
                    describing the elements of nature and their basic properties, healing values, and instructions for
                    their
                    use in supporting human spiritual and physical health. "Physica" can be seen as a practical guide to
                    folk medicine and monastic medicine. "Physic gardens" were the medicinal herb gardens belonging to
                    monasteries and medical schools, where plants were grown and studied.</p>

                <p>Hildegard's 9 recommendations for maintaining balance of mind, body, and spirit, which remain
                    relevant
                    today:
                    <ol>
                        <li>Know the elements of nature!</li>
                        <li>Reflect on the microcosm and macrocosm!</li>
                        <li>Maintain balance and harmony in both lifestyle and nutrition!</li>
                        <li>Be consistent and humble in working towards well-being!</li>
                        <li>Spend time outdoors, offering your body good rest in nature!</li>
                        <li>Practice moderation in lifestyle!</li>
                        <li>Maintain optimism and vitality based on values and self-development!</li>
                        <li>Treat your food as medicine!</li>
                        <li>Be with divine green energy, from which you can draw vitality!</li>
                    </ol>
                </p>

                <p>Hildegard's quote: "Illness is not a process, but the absence of a process, it is a failure to move
                along with nature."</p>
                <br/>

                <b>"Love gives birth to the human. Humility saves the human."</b>`

export const hildegardUk = `<h3><b>Хільдегарда Бінгенська (1098-1179)</b></h3>
<br>
<p>Хільдегарда була надзвичайно талановитою жінкою, чия робота продовжує надихати нас сьогодні. Вона була і бенедиктинською настоятелькою, і церковним лікарем, вченим і філософом, першопрохідцем і пророком, теологом і християнським містиком, композитором, художником і поетом.</p>

<p>Хільдегарда народилася в Німеччині як 10-та дитина в дворянській родині. Виховуючись у монастирі, вона отримала добру освіту. Її інтелект і велика начитаність заклали основу її різноманітних і систематичних знань. Незважаючи на те, що все своє життя прожила в Бінгені на Рейні, її робота торувала шлях у всьому світі протягом 900 років.</p>

<p>Свята Хільдегарда відома в Німеччині як засновниця альтернативної медицини. Як настоятелька вона відповідала за зцілення природними ліками. У першій частині її трактату «Physica» йдеться про 230 рослин, описуючи елементи природи та їхні основні властивості, цілющі властивості та вказівки щодо їх використання для підтримки духовного та фізичного здоров’я людини. «Physica» можна розглядати як практичний посібник з народної медицини та монастирської медицини. «Фізичними садами» були сади лікарських трав, що належали монастирям і медичним школам, де вирощували та вивчали рослини.</p>

<p>9 рекомендацій Хільдегарди для збереження балансу розуму, тіла і духу, які залишаються актуальними і сьогодні:
<ol>
<li>Пізнай стихію природи!</li>
<li>Розмірковуйте про мікрокосмос і макрокосмос!</li>
<li>Дотримуйтеся балансу та гармонії як у способі життя, так і в харчуванні!</li>
<li>Будьте послідовними та скромними у роботі задля добробуту!</li>
<li>Проводьте час на свіжому повітрі, пропонуючи своєму тілу повноцінний відпочинок на природі!</li>
<li>Дотримуйтеся помірності в способі життя!</li>
<li>Зберігайте оптимізм і бадьорість на основі цінностей і саморозвитку!</li>
<li>Ставтеся до їжі як до ліків!</li>
<li>Будьте з божественною зеленою енергією, з якої ви можете черпати життєві сили!</li></ol></p>

<p>Цитата Хільдегарди: «Хвороба — це не процес, а відсутність процесу, це неспроможність рухатися разом з природою».</p>
<br>
<b>«Любов народжує людину. Смирення рятує людину».</b>`